import { useMemo } from 'react'

import { FormConfig } from '@workwave-tidal/core/form'

import { PersonalizationForm } from './PersonalizationForm'
import { Footer } from './components/Footer'

import { usePersonalizationData } from '../hooks/usePersonalizationData'
import { useTexts } from './hooks/useTexts'

import { form } from './formState'
import { PersonalizationFormValues } from './typings'

type Props = {
  onDiscard: () => void
}

export function PersonalizationFormProvider(props: Props) {
  const { onDiscard } = props

  const texts = useTexts()

  // access form initial values and a function update the data when the form is saved
  const [personalization, updatePersonalization] = usePersonalizationData()

  const config = useMemo<FormConfig<PersonalizationFormValues>>(
    () => ({
      id: 'personalization-form',
      initialValues: personalization,
    }),
    [personalization],
  )

  return (
    <form.Form
      testId="personalization-form"
      data-trackid="personalization-form"
      title={texts.headerTitle}
      subtitle={texts.headerDescription}
      footer={<Footer />}
      onSubmit={formValues => updatePersonalization(formValues, onDiscard)}
      config={config}
      requireTransaction={false}
      stopEditingOnUnmount
      applyPendingFitMapOnMount={false}
    >
      <PersonalizationForm />
    </form.Form>
  )
}
